<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import Cta from "./widgets/CTA.svelte"
    import NewsEntry from "./widgets/NewsEntry.svelte"

    let offset = 0
    let news: NewsEntry[] = []
    const limit = 21
    let moreAvailable = true
    let loading = false

    function loadMore() {
        console.log("test")
        loading = true
        getCachedEntries(
            "content",
            {
                type: "news",
                active: true,
            },
            "-meta.date",

            limit,
            offset
        ).then((entries) => {
            entries.forEach((entry, i) => {
                if (i < 20) news.push(entry)
            })
            if (entries.length > 20) moreAvailable = true
            else moreAvailable = false
            offset += entries.length == 21 ? 20 : entries.length
            news = news
            loading = false
        })
    }
    loadMore()
</script>

<ul>
    {#each news as entry}
        <NewsEntry {entry} path="{entry.path}" />
    {/each}

    {#if moreAvailable}
        <Cta onClick="{loadMore}">mehr Laden</Cta>
    {/if}
</ul>

<style lang="less">
    ul {
        display: flex;
        flex-direction: column;
        gap: calc(var(--default-gap) / 2);
        width: 100%;
        max-width: 100%;
        align-items: center;
    }
</style>
